<script>
  'use strict'

  import {
    tileX,
    tileY,
    _tileMap,
    _tilesCollections,
    _tilesCollectionFileName,
    _selectedTileIdx,
    _newProject 
  } from '../store/store' 

  // -------------------------------------------------
  function createNewProject() {
    resetMap();
    resetTileCollection();
    localStorage.clear();
  }

  function resetMap() {
    tileX.set(5);
    tileY.set(5);
    _tileMap.set([]);
    clearMap();
  }

  function clearMap() {
    _newProject.set(true);
  }

  function clearTiles() {
    _tileMap.set([]);
    resetTileCollection();
    clearMap();
  }

  function resetTileCollection() {
    _tilesCollections.set([])
    _tilesCollectionFileName.set([]);
    _selectedTileIdx.set(0);
  }
</script>


<button on:click="{createNewProject}">NEW PROJECT</button>
<button on:click="{resetMap}">RESET MAP</button>
<button on:click="{clearMap}">CLEAR MAP</button>
<button on:click="{clearTiles}">CLEAR TILES</button>